import { render, staticRenderFns } from "./setOnlineTableColumnRule.vue?vue&type=template&id=388b9c95&scoped=true&"
import script from "./setOnlineTableColumnRule.vue?vue&type=script&lang=js&"
export * from "./setOnlineTableColumnRule.vue?vue&type=script&lang=js&"
import style0 from "./setOnlineTableColumnRule.vue?vue&type=style&index=0&id=388b9c95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b9c95",
  null
  
)

export default component.exports